<div class="bar-holder" [ngClass]="{ hidden: !showBarChart }">
  <div class="close" (click)="showBarChart=false">X</div>
  <svg id="programChart" width="800" height="490"></svg>
</div>

<ng-container *ngIf="programsLoaded && programService.programs.length !== 0">
  <top-menu *ngIf="!mobileView"
    [toggleData]="programExpandToggleData" 
    [showPrint]="true" 
    [showZoom]="true"
    [visibleItems]="visiblePrograms.size"
    [totalItems]="programsList.length"
    (editVisible)="editVisiblePrograms()"
  >
    <div *ngIf="!event?.is_readonly" class="toggle-holder top-menu-mid-right" [ngClass]="{selected: canDrag}">
      <div class="toggle-text" >DRAG AND DROP</div>
      <mat-slide-toggle class="white-toggle" [ngClass]="{selected: canDrag }" (change)="toggleDrag()" [checked]="canDrag"></mat-slide-toggle>
    </div>
  </top-menu>

  <!-- <mobile-menu *ngIf="mobileView">
    <dropdown *ngIf="programOptions?.length" class="top-right" 
      [selections]="programOptions" 
      [selected]="programOptions | findById:mobileProgramId" 
      (select)="$event.id === 'new' ? addProgram() : mobileProgramId = $event.id"
    ></dropdown> 
  </mobile-menu> -->
</ng-container>

<div class="null_state" *ngIf="programsLoaded && programService.programs.length === 0">
  <div class="thumbnail"></div>
  <h1>Program Builder</h1>
  <div *ngIf="!is_logistics && !event?.is_readonly">
    To start your program add a {{ uiService.programTerm.text }}<br />then add your sessions.
  </div>
  <div *ngIf="is_logistics || permissionsService.readonly[page_name]">
    There currently are no programs.  To add a program, contact a workforce member with program permissionsService.
  </div>
  <div *ngIf="event?.is_readonly">
    This event is read only.  No new programs can be added.
  </div>
  <button matButton="filled" color="primary" *ngIf="!is_logistics && !permissionsService.readonly[page_name] && !event?.is_readonly" (click)="addProgram()">+ Add a {{ uiService.programTerm.btn }}</button>
</div>

<zoom-wrapper [left]="'20px'" *ngIf="!mobileView && (!programsLoaded || programService.programs.length > 0) && programExpandToggleData.loaded">
  <ng-container [ngTemplateOutlet]="programs"></ng-container>
</zoom-wrapper>

<ng-container *ngIf="programService.programs | findById:mobileProgramId as lane">
  @if(!programExpandToggleData.loaded){
    <mat-progress-spinner style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);" mode="indeterminate"></mat-progress-spinner>
  }
  <program-lane *ngIf="mobileView && (!programsLoaded || programService.programs.length > 0) && programExpandToggleData.loaded && mobileProgramId"
    class="lane smooth"
    [id]="'lane_'+lane.id"
    [ngClass]="{ unloaded:!programExpandToggleData.loaded, expanded: !programExpandToggleData.leftSelected }"
    [lane]="lane"
    [venue]="event.venues[lane.venueId] || { venue: null, address: null }"
    [fullAccess]="!permissionsService.readonly[page_name] && !event?.is_readonly && programsLoaded && !is_logistics"
    [isLogistics]="is_logistics"
    [labelMaps]="labelMaps"
    [first]="true"
    [wide]="!programExpandToggleData.leftSelected"
    [showTimezones]="programTimezoneIds.size > 1"
    [event]="event"
    [dragging]="dragging"
    [draggedDay]="lane.id === draggedProgramId ? draggedDay : -1"
    (loading)="is_loaded = !$event"
    (editProgram)="editProgram(lane.id)"
    (editSession)="editSession($event)"
    (programDeleted)="removeVisible(lane.id)"
    (programDuplicatedId)="addVisible($event)"
  ></program-lane>
</ng-container>


<input #dummyInput class="scape_goat leave_in_here"/>
<div class="loading_indicator" [ngClass]="{is_loaded:is_loaded}">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>
<ng-template #programs>
  <div class="reloading" *ngIf="!!editingVisiblePrograms">Updating...</div>
  <div class="lanes_container" *ngIf="!editingVisiblePrograms" cdkDropListGroup >
    @for(lane of programsList; track lane.id; let idx = $index;){
      <div style="margin-left: 20px">
        <program-lane
          class="lane smooth"
          *ngIf="visiblePrograms.has(lane.id)"
          [id]="'lane_'+lane.id"
          [ngClass]="{ hidden: !visiblePrograms.has(lane.id), unloaded:!programExpandToggleData.loaded, expanded: !programExpandToggleData.leftSelected}"
          [lane]="lane"
          [venue]="event.venues[lane.venueId] || { venue: null, address: null }"
          [fullAccess]="readState !== manageSessionStates.ReadOnly && !permissionsService.readonly[page_name] && !event?.is_readonly && programsLoaded && !is_logistics"
          [isLogistics]="is_logistics"
          [labelMaps]="labelMaps"
          [canDrag]="canDrag && !event?.is_readonly"
          [dragging]="dragging"
          [draggedDay]="lane.id === draggedProgramId ? draggedDay : -1"
          [first]="!idx"
          [wide]="!programExpandToggleData.leftSelected"
          [showTimezones]="programTimezoneIds.size > 1"
          [event]="event"
          (loading)="is_loaded = !$event"
          (editProgram)="editProgram(lane.id)"
          (editSession)="editSession($event)"
          (programDeleted)="removeVisible(lane.id)"
          (programDuplicatedId)="addVisible($event)"
          (showBarChart)="debugProgram(lane)"
        ></program-lane>
      </div>
    }
    <ng-container *ngFor="let lane of programsList; index as idx; trackBy:trackByProgram">
    </ng-container>
  </div>
  <menu-hover-button class="hidden-notice" [noWrap]="false" [iconSelector]="'hidden_eye'" *ngIf="visiblePrograms.size < programsList.length"
    [hoverText]="'Click on EDIT VISIBLE above\nto unhide Room / Locations'"></menu-hover-button>
  <div class="add_lane_btn" *ngIf="!editingVisiblePrograms && !permissionsService.readonly[page_name] && !event?.is_readonly && programsLoaded && !is_logistics">
    <button mat-button class="large" (click)="addProgram()" *ngIf="!addInputView"> + Add a {{ uiService.programTerm.btn }}</button>
  </div>
  <div class="background_text" *ngIf="!programsLoaded">
    Program information is loading...
  </div>
</ng-template> 